import * as React from 'react';
import Box from '@mui/material/Box';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';

const steps = [
  'Validar placa',
  'Ingresar detalles del carro',
  'Subir imagenes del carro',
  'Revisión',
  'Finalizar',
];

export default function HorizontalLabelPositionBelowStepper({ step }) {
  return (
    <Box sx={{ width: '95%', margin: '0.1rem auto 1rem auto' }}>
      <Stepper activeStep={step} alternativeLabel>
        {steps.map((label) => (
          <Step key={label}>
            <StepLabel>{label}</StepLabel>
          </Step>
        ))}
      </Stepper>
    </Box>
  );
}
